export { default } from './AccommodationMap';
export type { Props, Props as AccommodationMapProps } from './AccommodationMap';
